import { render, staticRenderFns } from "./import_config.vue?vue&type=template&id=3ab91f5c&scoped=true"
import script from "./import_config.vue?vue&type=script&lang=js"
export * from "./import_config.vue?vue&type=script&lang=js"
import style0 from "./import_config.vue?vue&type=style&index=0&id=3ab91f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab91f5c",
  null
  
)

export default component.exports